import HelpSupportPageLayer from "../components/HelpSupportPageLayer";
import SuperAdminDashLayout from "../masterLayout/SuperAdminDashLayout";

const HelpSupportPage = () => {
  return (
    <>
      <SuperAdminDashLayout>
        <HelpSupportPageLayer />
      </SuperAdminDashLayout>
    </>
  );
};

export default HelpSupportPage;
